import * as $ from 'jquery';


const colorboxDefaults = {
	transition: 'fade',
	fixed: true,

	opacity: .9,
	scalePhotos: true,
	maxWidth: '90%',
	maxHeight: '90%',
	initialWidth: 500,
	initialHeight: 300,
	scrolling: false,
	next: '',
	previous: '',
	rel: 'colorbox',
	close: '<span>Close</span>'
};

export default class Colorbox {
	constructor() {
		const selector_component = '.collapsableGroup';
		const selector_targets = '.floorPlan__media a, .floorPlan__tour a';

		$(selector_targets).colorbox(colorboxDefaults);

		// const analytics = Analytics.getInstance();
		// const trackControlEvent = (label: string) => analytics.trackEvent('Image Collection', 'Control Click', label);

		let resizeInterval: ReturnType<typeof setInterval> = undefined;

		const announcementLightboxOptions = $.extend({}, colorboxDefaults, {
			className: 'announcementLightbox',
			open: true,
			rel: '',
			inline: true,
			href: '.announcementLightbox__content',
			onComplete: () => {
				// Needed because custom font doesn't always load right away

				// Resize once now
				$.colorbox.resize();

				// and start interval to refresh every second until lightbox is closed
				if (resizeInterval !== undefined) {
					clearInterval(resizeInterval);
				}
				setTimeout(() => $.colorbox.resize(), 200);
				setTimeout(() => $.colorbox.resize(), 500);
				resizeInterval = setInterval(() => $.colorbox.resize(), 1000);
			},
			onClosed: () => {
				// Stop interval
				clearInterval(resizeInterval);
				resizeInterval = undefined;
			}
		});

		if ($('.hasAnnouncement').length === 1) {
			$.colorbox(announcementLightboxOptions);
		}
	}

}
